var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"mention-content-wrapper\">"
    + container.escapeExpression((((helper = lookupProperty(helpers,"mention_text") || container.strict(depth0, "mention_text", {"start":{"line":2,"column":41},"end":{"line":2,"column":53}} ))),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"mention_text","hash":{},"data":data,"loc":{"start":{"line":2,"column":38},"end":{"line":2,"column":56}}}) : helper)))
    + "</span>";
},"useData":true});